function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "avatar-4-a",
  width: 70,
  height: 70,
  rx: 24
}), React.createElement("linearGradient", {
  id: "avatar-4-c",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E6864E"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#E67240"
})), React.createElement("linearGradient", {
  id: "avatar-4-d",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFC9B3"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFD2C2"
})), React.createElement("linearGradient", {
  id: "avatar-4-e",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFD4B3"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFDCC2"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "avatar-4-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-4-a"
})), React.createElement("use", {
  fill: "#A0A6B8",
  opacity: 0.1,
  xlinkHref: "#avatar-4-a"
}), React.createElement("g", {
  mask: "url(#avatar-4-b)"
}, React.createElement("path", {
  d: "M3.5 7h63v63h-63z"
}), React.createElement("path", {
  fill: "url(#avatar-4-c)",
  d: "M1.316 27.05C-.482 21.023-1.59 10.72 5.973 3.672c5.78-5.386 21.396-5.929 26.828 5.816.907 1.96-.332 5.034-2.771 4.922-.959-.044-1.552 3.02-2.107 4.922.776 7.718 7.69 7.86 11.197 13.759 4.324 7.27-.997 18.009-13.746 18.009-12.75 0-20.058-10.648-24.058-24.05z",
  transform: "matrix(-1 0 0 1 51.1 10.5)"
}), React.createElement("path", {
  fill: "url(#avatar-4-d)",
  d: "M45.17 45.004c1.08 2.082 1.89 6.914 2.43 14.496H2.1c.54-7.582 1.35-12.414 2.43-14.496 1.62-3.122 8.393-6.69 20.32-10.704 11.927 4.014 18.7 7.582 20.32 10.704z",
  transform: "translate(10.5 10.5)"
}), React.createElement("path", {
  fill: "url(#avatar-4-e)",
  d: "M30.006 36.948c-1.879 1.035-3.683 1.552-5.411 1.552-1.729 0-3.457-.517-5.185-1.552v-4.876c-.661.118-1.168.1-1.687.1-5.296 0-7.293-7.745-6.26-17.169.662 0 2.207 0 4.414-3.103-.551 4.322 5.85 3.657 8.279.222-1.214 4.1 1.987 6.871 4.746 5.209 5.41-3.26 6.627 6.678 1.104 6.76v12.857z",
  transform: "translate(10.5 10.5)"
}), React.createElement("path", {
  fill: "#FFB597",
  fillRule: "nonzero",
  d: "M29.96 42.627c2.933-.532 5.5-1.558 7.7-3.077-1.833 3.267-4.4 4.9-7.7 4.9v-1.823z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M35.217 48.699c1.598-.071 5.298-.839 5.298-2.498V44.8c.406 0 1.567.94 2.163 1.735 2.36 3.145-.257 5.965-2.392 5.965-2.694 0-4.479-2.208-5.076-3.27-.597 1.062-2.382 3.27-5.076 3.27-2.135 0-4.753-2.82-2.392-5.965.596-.795 1.757-1.735 2.163-1.735v1.401c0 1.659 3.8 2.427 5.312 2.498z"
})));

var SvgAvatar5 = function SvgAvatar5(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar-5.7c3726fa.svg";
export { ForwardRef as ReactComponent };